<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    ref="gc-base-layout"
    class="sample-request"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Sample Request'"
        :createModeIsEditMode="false"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode != 'create' ? 'Sample Request # ' + baseView.id : ''
        "
        :secondaryLabel="
          baseView.mode != 'create' ? dataModel.CustomerName : ''
        "
        v-if="loaded"
      />
    </template>

    <div class="css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? dataModel : {}"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
          :customButtons="getCustomButtons"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form">
        <div class="header-form-container">
          <div class="header-form">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="headerFormOptions"
                :formItems="leftFormItems"
                :isNormal="true"
                :data-model="dataModel"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-form'"
                ref="gc-header-form"
                :checkValid="isValid"
                :validationGroup="'gc-header-form-left'"
                :scrollingEnabled="false"
                :formContentReady="onHeaderFormContentReady"
              ></gc-form>
            </div>
          </div>
          <div class="header-comments">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="headerFormOptions"
                :formItems="rightFormItems"
                :isNormal="true"
                :data-model="dataModel"
                :deliveryAddressClicked="undefined"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-form-right'"
                ref="gc-header-form-right"
                :validationGroup="'gc-header-form-right'"
                :scrollingEnabled="true"
                :headerUpdateOff="true"
                :checkValid="isValid"
              ></gc-form>
            </div>
          </div>
        </div>
      </div>

      <div
        class="gc-details-grid"
        v-bind:class="
          baseView.mode == 'review' ? 'gc-details-grid-review-mode' : ''
        "
      >
        <gc-filter-split-view
          :showLeftContainer="showLeftContainer"
          :showRightContainer="showRightContainer"
          :rightContainerWidth="250"
        >
          <template #leftContent>
            <dx-data-grid
              :height="getGridHeight"
              :data-source="getDataSource"
              :on-row-removed="onRowRemoved"
              :ref="'sample-request-grid'"
              @editor-preparing="onEditorPreparing"
              :key-expr="'ID'"
              :column-chooser="{
                enabled: false,
              }"
              :repaintChangesOnly="false"
              :twoWayBindingEnabled="true"
            >
              <DxLoadPanel :show-indicator="false" :enabled="false" />
              <DxPaging :page-size="50" :enabled="false" />
              <DxPager :visible="false" />

              <DxScrolling
                :mode="'virtual'"
                :row-rendering-mode="'virtual'"
                :preload-enabled="true"
                :renderAsync="false"
                :useNative="false"
              />

              <DxEditing
                :allow-updating="true"
                :allow-deleting="dataModel.Status == 'Pending'"
                mode="cell"
                :new-row-position="'last'"
                :use-icons="true"
                :select-text-on-edit-start="true"
              />
              <DxColumn
                data-field="ProductCode"
                caption="Product"
                :allow-editing="isGridCellEditable"
                :show-editor-always="false"
                editCellTemplate="product-template"
                :css-class="
                  isGridCellEditable
                    ? 'gc-editable-field  gc-editor-product-cell'
                    : 'gc-editable-field'
                "
                :setCellValue="onProductValueChanged"
                :minWidth="getColumnMinWidth('TransactionAccount')"
                :validationRules="[
                  {
                    type: 'required',
                    message: 'Product is required',
                  },
                ]"
                :fixed="true"
                fixedPosition="left"
              />

              <!-- :setCellValue="onProductValueChanged" -->

              <template #product-template="{ data: cellInfo }">
                <div>
                  <DxSelectBox
                    :data-source="getProductDataSource"
                    :searchEnabled="true"
                    searchMode="contains"
                    :display-expr="'Code'"
                    :value-expr="'Code'"
                    :itemTemplate="
                      (data) => {
                        return `<div class='custom-auto-complete' id='${data.Code}'>
                          <span class='auto-complete-primary'> ${data.Code} </span>
                          <span class='record-secondary gc-grid-code'>
                            ${data.Description1}
                          </span>
                        </div>`;
                      }
                    "
                    @selection-changed="onProductItemClick($event, cellInfo)"
                    :value="cellInfo.value"
                    :drop-down-options="{
                      width: 350,
                    }"
                    :searchTimeout="10"
                    @key-down="onEditorKeyDown($event, cellInfo)"
                    @initialized="
                      onProductSelectionInitialized($event, cellInfo)
                    "
                  />
                </div>
              </template>

              <!-- :on-key-down="
                    (e) => {
                      onEditorKeyDown(e, cellInfo);
                    }
                  "
                  @keyUp="onProdValueChanged" -->

              <DxColumn
                data-field="Description1"
                caption="Description"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                editCellTemplate="description-template"
                css-class="gc-editable-field"
                :width="getColumnWidth('ProductDescription')"
                :minWidth="getColumnMinWidth('ProductDescription')"
              />

              <template #description-template="{ data: cellInfo }">
                <div>
                  <DxTextBox
                    :value="cellInfo.value"
                    :on-value-changed="
                      (e) => {
                        cellInfo.setValue(e.value);
                      }
                    "
                    :disabled="cellInfo.data.StockItem == 'Y'"
                  />
                </div>
              </template>

              <DxColumn
                data-field="SampleSize"
                caption="Sample Size"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                editCellTemplate="sample-size-template"
                css-class="gc-editable-field"
                format="###,##0.00"
                :width="getColumnWidth('Quantity')"
                :minWidth="getColumnMinWidth('Quantity')"
                :validationRules="[
                  {
                    type: 'range',
                    message: 'Sample Size should be grater than 0',
                    min: 0.01,
                  },
                ]"
              />

              <template #sample-size-template="{ data: cellInfo }">
                <div>
                  <DxNumberBox
                    :value="cellInfo.value"
                    format="###,##0.00"
                    :on-value-changed="
                      (e) => {
                        cellInfo.setValue(e.value);
                      }
                    "
                    :disabled="cellInfo.data.StockItem != 'N'"
                    :min="0"
                  />
                </div>
              </template>

              <DxColumn
                data-field="Quantity"
                caption="Quantity"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                css-class="gc-editable-field"
                format="###,##0.00"
                :editor-options="{
                  format: '###,##0.00',
                  onKeyDown: onEditorKeyDown,
                  min: 0,
                }"
                data-type="number"
                :width="getColumnWidth('Quantity')"
                :minWidth="getColumnMinWidth('Quantity')"
                :validationRules="[
                  {
                    type: 'range',
                    message: 'Quantity should be grater than 0',
                    min: 1,
                  },
                ]"
              />
              <DxColumn
                data-field="Price"
                caption="Price"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                css-class="gc-editable-field"
                format="###,##0.00"
                :editor-options="{
                  format: '###,##0.00',
                }"
                data-type="number"
                :width="getColumnWidth('Amount')"
                :minWidth="getColumnMinWidth('Amount')"
              />

              <!-- <DxColumn
                :data-field="
                  baseView.mode != 'review' ? 'Status' : 'FriendlyStatus'
                "
                caption="Status"
                :allow-editing="baseView.mode != 'review'"
                :show-editor-always="baseView.mode != 'review'"
                css-class="gc-editable-field"
                width="120"
                editCellTemplate="status-template"
              />

              <template #status-template="{ data: cellInfo }">
                <div>
                  <DxSelectBox
                    :items="getLineStatusItems(cellInfo.data)"
                    value-expr="value"
                    display-expr="text"
                    :on-value-changed="
                      (e) => {
                        cellInfo.setValue(e.value);
                      }
                    "
                    :value="cellInfo.data.Status"
                  />
                </div>
              </template> -->

              <DxColumn
                data-field="SourceFrom"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                css-class="gc-editable-field"
                :editor-options="{
                  maxLength: 100,
                }"
                data-type="string"
                :width="getColumnWidth('ProductDescription')"
                :minWidth="getColumnMinWidth('ProductDescription')"
              />

              <DxColumn
                data-field="Instructions"
                :editor-options="{
                  maxLength: 1000,
                }"
                :allow-editing="isGridCellEditable"
                :show-editor-always="isGridCellEditable"
                css-class="gc-editable-field instructions-text"
                :width="getColumnWidth('Comment')"
                :minWidth="getColumnMinWidth('Comment')"
                editCellTemplate="instructions-template"
              />

              <template #instructions-template="{ data: cellInfo }">
                <div>
                  <DxTextArea
                    :value="cellInfo.data.Instructions"
                    @value-changed="
                      (e) => {
                        cellInfo.setValue(e.value);
                      }
                    "
                    :auto-resize-enabled="false"
                    :element-attr="{
                      class:
                        baseView.mode == 'review'
                          ? 'instructions-text-area review-mode'
                          : 'instructions-text-area',
                    }"
                    :height="baseView.mode == 'review' ? 30 : 50"
                    :disabled="baseView.mode == 'review'"
                  />
                </div>
              </template>

              <DxColumn
                data-field=""
                caption=""
                type="buttons"
                alignment="right"
                maxWidth="50"
                :buttons="[
                  {
                    hint: 'Add',
                    icon: 'plus',
                    onClick: addNewRow,
                  },
                  'delete',
                ]"
                :visible="
                  baseView.mode != 'review' && dataModel.Status == 'Pending'
                "
              />
            </dx-data-grid>
          </template>
          <template #rightContent> </template>
        </gc-filter-split-view>

        <GcFooter />
      </div>
    </div>

    <GcPopupCustomerAndContact
      :visible="visibleAddCustomer"
      :setLoading="showLoading"
      :callback="addCustomerCallBack"
      :displayValidationSummary="displayValidationSummary"
      :displayServerError="displayServerError"
      :selectedCustomerData="selectedCustomerData"
      v-if="visibleAddCustomer"
    />
  </GcBaseLayout>
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import ArrayStore from "devextreme/data/array_store";
import { ProductService } from "../../../_services/api/products/product.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import validationEngine from "devextreme/ui/validation_engine";
import { SampleRequestService } from "../../../_services/api/sales/sample-request.service";
import GcPopupCustomerAndContact from "../../../popups/gc-popup-customer-and-contact";
import { CustomerContactService } from "../../../_services/api/customers/customer-contact.service";
import { CustomerService } from "../../../_services/api/customers/customer.service";
import DataSource from "devextreme/data/data_source";

const SampleRequestStatuses = [
  "Pending",
  "Complete",
  "Cancelled",
  "Prepared",
  "Sent",
  "Notified",
];

let baseLine = {
  ProductCode: undefined,
  Description1: undefined,
  StockItem: undefined,
  SampleSize: 0,
  Quantity: 0,
  Price: 0,
  Status: undefined,
  SourceFrom: undefined,
  Instructions: undefined,
};

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: { GcPopupCustomerAndContact },
  data() {
    return {
      loaded: false,
      dataModel: {
        CustomerCode: undefined,
        ContactCode: undefined,
        ConsignmentNote: undefined,
        CustomerNotifiedBy: undefined,
        CustomerNotifiedDate: undefined,
        MailCountry: undefined,
        MailPostCode: undefined,
        MailState: undefined,
        MailStreet1: undefined,
        MailStreet2: undefined,
        MailSuburb: undefined,
        RequestedBy: undefined,
        RequestedDate: new Date(),
        SampleSentBy: undefined,
        SampleSentDate: undefined,
        Status: "Pending",
        FreightCarrierCode: undefined,
        FreightCarrierPreparedBy: undefined,
        ContactPhoneNo: undefined,
        PreparedBy: undefined,
        PreparedDate: undefined,
        CustomerContactCode: undefined,
        ContactMobileNo: undefined,
        Email: undefined,
        CustomerName: undefined,
      },
      isValid: false,
      headerFormOptions: {
        gcLabelLocation: "left",
      },
      showLeftContainer: true,
      showRightContainer: false,
      headerFormHeight: 0,

      localDataSourceItems: new ArrayStore({
        key: "ID",
        data: [],
      }),
      selectedProducts: [],
      visibleAddCustomer: false,
      headerToolBarForm: undefined,
      lineStatusItems: [
        { value: "A", text: "Active", visible: true },
        { value: "P", text: "Pending", visible: true },
        { value: "R", text: "Rejected", visible: true },
        { value: "S", text: "Sold", visible: true },
      ],
      selectedCustomerData: undefined,
    };
  },
  async created() {
    if (this.baseView.query && this.baseView.query.cus_id)
      this.dataModel.CustomerCode = this.baseView.query.cus_id;
    this.showLoading(true);
    await this.initialized();

    this.loaded = true;
    this.showLoading(false);
  },
  methods: {
    onProductSelectionInitialized(e, cellInfo) {
      if (!cellInfo.data.ProductCode) {
        e.component.reset();
        e.component.option("dropDownOptions", { width: 350, height: 500 });
        let ds = e.component.getDataSource();
        ds.filter(["Inactive", "=", "N"]);

        e.component.option("value", undefined);
        // let ds = e.component.getDataSource();
        ds.load();
      }
    },
    // onProductCodeChanged(e, cellInfo) {
    //   let newData = {};
    //   newData.ProductCode = e.value;
    //   let product = this.selectedProducts.filter(
    //     (x) => x.Code == newData.ProductCode
    //   );
    //   if (product.length > 0) {
    //     newData.Description1 = product[0].Description1;
    //     newData.StockItem = product[0].StockItem;
    //     if (newData.StockItem == "Y") {
    //       newData.SampleSize = product[0].PackSize;
    //     } else {
    //       newData.SampleSize = 0.2;
    //     }
    //   }
    //   console.log("newData ", newData);
    //   this.localDataSourceItems.update(cellInfo.key.ID, newData);
    //   let dataGrid = this.$refs["sample-request-grid"].instance;
    //   if (dataGrid) {
    //     dataGrid.refresh(true);
    //   }
    //   console.log("localDataSourceItems ", this.localDataSourceItems);
    // },
    // Add new customer

    focusToolbarFormElement(controlElementRef) {
      this.$nextTick(() => {
        let formInstance =
          this.$refs["gc-form-header-toolbar"].$refs["toolbar-form"].$refs[
            "gc-form-comp"
          ].instance;

        formInstance &&
          formInstance.getEditor(controlElementRef) &&
          formInstance.getEditor(controlElementRef).instance().focus();
      });
    },

    focusLeftFormElement(controlElementRef) {
      this.$nextTick(() => {
        let formInstance =
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

        formInstance &&
          formInstance.getEditor(controlElementRef) &&
          formInstance.getEditor(controlElementRef).instance().focus();
      });
    },
    focusRightFormElement(controlElementRef, movingForward) {
      this.$nextTick(() => {
        let formInstance =
          this.$refs["gc-header-form-right"].$refs["gc-form-comp"].instance;

        if (
          formInstance &&
          formInstance.getEditor(controlElementRef).option("disabled")
        ) {
          if (movingForward) {
            this.moveCellFoucs({ rowIndex: 0 }, "ProductCode");
          } else {
            let focusSet = false;
            [
              "CustomerNotifiedDate",
              "CustomerNotifiedBy",
              "ConsignmentNote",
              "FreightCarrierCode",
              "SampleSentDate",
              "SampleSentBy",
              "PreparedDate",
              "PreparedBy",
              "RequestedDate",
            ].forEach((element) => {
              if (
                !formInstance.getEditor(element).option("disabled") &&
                !focusSet
              ) {
                focusSet = true;
                formInstance.getEditor(element).instance().focus();

                return;
              }
            });
          }
          return;
        }

        if (formInstance) {
          formInstance.getEditor(controlElementRef) &&
            formInstance.getEditor(controlElementRef).instance().focus();
        }
      });
    },
    addCustomerCallBack(data) {
      this.visibleAddCustomer = false;

      if (data) {
        this.dataModel.CustomerCode = data.data.CustomerCode;
        if (data.data.CustomerContact && data.data.CustomerContact.FirstName) {
          this.dataModel.CustomerContactCode = data.data.CustomerContact.LineNo;

          setTimeout(() => {
            let formInstance =
              this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
            if (formInstance) {
              let contactField = formInstance
                .getEditor("CustomerContactCode")
                .getDataSource();
              if (contactField)
                contactField.load().then(() => {
                  let field = formInstance
                    .getEditor("CustomerContactCode")
                    .instance();
                  if (field)
                    field.option("value", data.data.CustomerContact.LineNo);
                });
            }
          }, 50);
        }
      }
    },
    onVisibleAddNewCustomer() {
      this.visibleAddCustomer = true;
    },

    onEditorPreparing(e) {
      if (e.parentType != "searchPanel") {
        if (e.dataField == "Quantity") {
          let func = e.editorOptions.onKeyDown;
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }
      }
    },
    onRowRemoved() {
      if (this.localDataSourceItems._array.length == 0) {
        this.localDataSourceItems.insert({ ...baseLine });
      }
    },
    addNewRow(e) {
      let rowDate = e.row.data;
      if (!rowDate.ProductCode) {
        this.displayValidationSummary([{ message: "Product is required" }]);
      } else if (rowDate.SampleSize <= 0) {
        this.displayValidationSummary([
          { message: "Sample Size should be grater than 0" },
        ]);
      } else if (rowDate.Quantity <= 0) {
        this.displayValidationSummary([
          { message: "Quantity should be grater than 0" },
        ]);
      } else {
        this.showLoading(true);
        let newLine = { ...baseLine };
        newLine.isNewLine = true;
        this.localDataSourceItems.insert({ ...newLine }).then(() => {
          let dataGrid = this.$refs["sample-request-grid"].instance;
          if (dataGrid) {
            dataGrid.saveEditData().then(() => {
              dataGrid.refresh(true);
              setTimeout(() => {
                this.showLoading(false);
                setTimeout(() => {
                  let rowIndex = dataGrid.getRowIndexByKey(
                    this.localDataSourceItems._array[
                      this.localDataSourceItems._array.length - 1
                    ]
                  );
                  if (rowIndex != -1) {
                    this.moveCellFoucs({ rowIndex: rowIndex }, "ProductCode");
                  }
                }, 100);
              }, 500);
            });
          } else {
            this.showLoading(false);
          }
        });
      }
    },
    getColumnWidth(Column) {
      return ColumnWidth.getValue(Column).width;
    },
    getColumnMinWidth(Column) {
      return ColumnWidth.getValue(Column).minWidth;
    },
    async initialized() {
      if (this.baseView.mode != "create") {
        await SampleRequestService.getSampleRequestRecord(this.baseView.id)
          .then((res) => {
            if (res.data.value.length > 0) {
              this.dataModel = Object.assign(res.data.value[0], {
                Email: undefined,
                ContactMobileNo: undefined,
                ContactPhoneNo: undefined,
              });
              this.dataModel.CustomerContactCode = this.dataModel.ContactCode;
              this.dataModel.FreightCarrierCode = this.dataModel.CarrierID;
            }
          })
          .catch((err) => {
            this.displayServerError(err, "Server Error !");
          });

        let customerData = await CustomerService.getByCode(
          this.dataModel.CustomerCode
        );
        this.selectedCustomerData = customerData.data.value[0];

        await CustomerContactService.getByCustomerCodeLineNo(
          this.dataModel.CustomerCode,
          this.dataModel.CustomerContactCode
        ).then((res) => {
          this.dataModel.Email = res.data.value[0].Email;
          this.dataModel.ContactMobileNo = res.data.value[0].Mobile;
          this.dataModel.ContactPhoneNo = res.data.value[0].Phone;
        });

        await SampleRequestService.getSampleRequestDetails(this.baseView.id)
          .then((res) => {
            res.data.value.forEach((element) => {
              let FriendlyStatus = this.lineStatusItems.filter(
                (x) => x.value == element.LineStatus
              );
              this.localDataSourceItems.insert({
                ProductCode: element.ItemCode,
                Description1: element.ItemDescription,
                StockItem: element.StockItem,
                SampleSize: element.SampleSize,
                Quantity: element.SampleQuantity,
                Price: element.UnitPrice,
                Status: element.LineStatus,
                SourceFrom: element.SourceFrom,
                Instructions: element.SpecialInstruction,
                FriendlyStatus:
                  FriendlyStatus.length != 0 ? FriendlyStatus[0].text : "",
                LineStatus: element.LineStatus,
              });
            });
          })
          .catch((err) => {
            this.displayServerError(err, "Server Error !");
          });
      } else this.localDataSourceItems.insert({ ...baseLine });
    },
    onHeaderFormContentReady(e) {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      this.headerDxFormHeight = e.element.offsetHeight;
    },

    toolBarFormContentReady(e) {
      if (e && this.baseView.mode != "review" && this.loaded)
        setTimeout(() => {
          this.headerToolBarForm = e.component;
          if (
            this.headerToolBarForm &&
            this.headerToolBarForm.getEditor("CustomerCode")
          )
            this.headerToolBarForm.getEditor("CustomerCode").instance().focus();
        }, 500);
    },
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },
    async checkHeaderFormValidation(status) {
      if (status && SampleRequestStatuses.includes(status))
        this.dataModel.Status = status;
      let validationResult = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      let headerform = await validationEngine.validateGroup(
        "gc-header-form-left"
      );
      let headerformRight = await validationEngine.validateGroup(
        "gc-header-form-right"
      );
      if (
        !validationResult.isValid ||
        !headerform.isValid ||
        !headerformRight.isValid
      )
        this.displayValidationSummary(
          validationResult.brokenRules
            .concat(headerform.brokenRules)
            .concat(headerformRight.brokenRules)
        );
      else {
        let sampleItems = this.localDataSourceItems._array.filter(
          (x) => x.ProductCode
        );
        if (sampleItems.length == 0) {
          this.displayValidationErrors([
            "Sample has no detail. Please add one or more lines before attempting to save the sample request again.",
          ]);
          return;
        } else {
          let payload = {
            PreparedBy: this.dataModel.PreparedBy,
            PreparedDate: this.dataModel.PreparedDate
              ? new Date(this.dataModel.PreparedDate).toSaveDate()
              : undefined,
            CarrierID: this.dataModel.FreightCarrierCode,
            CarrierName: this.dataModel.FreightCarrierPreparedBy,
            // ChangedBy: "Jim",
            ConsignmentNote: this.dataModel.ConsignmentNote,
            ContactCode: this.dataModel.CustomerContactCode.toString(),
            // CreatedBy: "string",
            CustomerCode: this.dataModel.CustomerCode,
            CustomerNotifiedBy: this.dataModel.CustomerNotifiedBy,
            CustomerNotifiedDate: this.dataModel.CustomerNotifiedDate
              ? new Date(this.dataModel.CustomerNotifiedDate).toSaveDate()
              : undefined,
            // DateChanged: "2024-04-25T02:55:37.466Z",
            // DateCreated: "2024-04-25T02:55:37.466Z",
            MailCountry: this.dataModel.MailCountry,
            MailPostCode: this.dataModel.MailPostCode,
            MailState: this.dataModel.MailState,
            MailStreet1: this.dataModel.MailStreet1,
            MailStreet2: this.dataModel.MailStreet2,
            MailSuburb: this.dataModel.MailSuburb,
            // RecordID: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            RequestedBy: this.dataModel.RequestedBy,
            RequestedDate: this.dataModel.RequestedDate
              ? new Date(this.dataModel.RequestedDate).toSaveDate()
              : undefined,
            SampleCode: this.baseView.mode != "create" ? this.baseView.id : 0,
            SampleSentBy: this.dataModel.SampleSentBy,
            SampleSentDate: this.dataModel.SampleSentDate
              ? new Date(this.dataModel.SampleSentDate).toSaveDate()
              : undefined,
            Status: this.dataModel.Status,
            CustomerSampleRequestDetails: [],
          };

          payload.CustomerSampleRequestDetails =
            this.localDataSourceItems._array
              .filter((p) => p.ProductCode)
              .map((x) => {
                return {
                  ItemCode: x.ProductCode,
                  ItemDescription: x.Description1,
                  LineNo: 0,
                  LineStatus: x.Status,
                  MicroAnalysis: "s",
                  // RecordID: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  // SampleCode: 1000,
                  SampleQuantity: x.Quantity,
                  SampleSize: x.SampleSize,
                  SourceFrom: x.SourceFrom ? x.SourceFrom : " ",
                  // SpecCode: "string",
                  SpecialInstruction: x.Instructions,
                  // SpecsIncluded: "s",
                  // StockItem: "S",
                  UnitPrice: x.Price,
                };
              });

          let errorLines = payload.CustomerSampleRequestDetails.filter(
            (x) => x.SampleSize <= 0 || x.Quantity <= 0
          );
          if (errorLines.length > 0) {
            this.displayValidationSummary([
              { message: "Sample Size & Quantity should be grater than 0" },
            ]);
            return;
          }

          this.showLoading(true);

          await SampleRequestService.saveSampleRequest(payload)
            .then((res) => {
              this.showLoading(false);
              this.$notify(`Sample request successfully created`, "success");
              this.setIgnoreRouteChangeConfirmation();
              if (res) {
                this.$router.push({
                  path: `/sample-request`,
                });
              }
            })
            .catch((err) => {
              if (err) this.showLoading(false);

              this.displayServerError(err, "Save Sample Request Failed");
            });
        }
      }
    },

    headerFormValueChanged(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
      // else {
      // }
    },
    // valueChangeCallBack(a, b, c) {
    //   console.log("valueChangeCallBack ", a, b, c);
    // },
    onProductItemClick(e, cellInfo) {
      let item = e.selectedItem;
      if (cellInfo.data.ProductCode != item.Code) {
        let newData = {};
        newData.ProductCode = item.Code;
        newData.Description1 = item.Description1;
        newData.StockItem = item.StockItem;
        if (newData.StockItem == "Y") {
          newData.SampleSize = item.PackSize;
        } else {
          newData.SampleSize = 0.2;
        }

        if (item.StockItem == "Y") {
          // this.moveCellFoucs(cellInfo, "Quantity");
        }
        this.localDataSourceItems.update(cellInfo.key.ID, newData).then(() => {
          cellInfo.component.refresh(true);
        });
      }
    },
    onProductValueChanged(newData, value, rowData) {
      newData.ProductCode = value;
      // let product = this.selectedProducts.filter((x) => x.Code == value);
      // if (product.length > 0) {
      //   newData.Description1 = product[0].Description1;
      //   newData.StockItem = product[0].StockItem;
      //   if (newData.StockItem == "Y") {
      //     newData.SampleSize = product[0].PackSize;
      //   } else {
      //     newData.SampleSize = 0.2;
      //   }
      // }
      // // newData.Quantity = 0.2;
      // let dataGrid = this.$refs["sample-request-grid"].instance;
      // if (dataGrid) {
      //   dataGrid.saveEditData();
      // }

      newData = Object.assign(newData, rowData);

      return newData;
    },
    onEditorKeyDown(e, cellInfo) {
      // if (e.event.keyCode == 9 && !e.event.shiftKey) {
      if (cellInfo.column.dataField == "ProductCode") {
        if (e.event.keyCode == 9 && !e.event.shiftKey) {
          if (cellInfo.data.StockItem == "Y") {
            e.event.preventDefault();
            this.moveCellFoucs(cellInfo, "Quantity");
          } else {
            e.event.preventDefault();
            this.$nextTick(() => {
              this.moveCellFoucs(cellInfo, "Description1");
            });
          }
        } else if (e.event.keyCode == 9 && e.event.shiftKey) {
          if (cellInfo.rowIndex == 0) {
            e.event.preventDefault();
            this.focusRightFormElement("CustomerNotifiedDate", false);
          }
        }
      }
      // }

      if (e.event.keyCode == 9 && e.event.shiftKey) {
        if (cellInfo.column.dataField == "Quantity") {
          if (cellInfo.data.StockItem == "Y") {
            e.event.preventDefault();
            this.moveCellFoucs(cellInfo, "ProductCode");
          }
        }
      }
    },
    moveCellFoucs(cellInfo, nextColumn) {
      let dataGrid = this.$refs["sample-request-grid"].instance;
      if (dataGrid) {
        var rowIndex = cellInfo.rowIndex;
        var cellElement = dataGrid.getCellElement(rowIndex, nextColumn);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, nextColumn);
        }, 10);
      }
    },
    onFreightCarrierChanged(e) {
      this.dataModel.FreightCarrierPreparedBy = e.selectedItem.SupplierName;
    },
    onCustomerContactChanged(e) {
      // if (this.baseView.mode === "review") return;

      if (e.component.getDataSource()) {
        var customerContact = e.component
          .getDataSource()
          ._items.find((x) => x.LineNo == e.value);

        if (customerContact) {
          let data = customerContact;

          this.dataModel.MailPostCode = data.PhysicalAddressPostcode;
          // data.Email;

          this.dataModel.MailState = data.PhysicalAddressState;
          this.dataModel.MailStreet1 = data.PhysicalAddressStreetLine1;
          this.dataModel.MailStreet2 = data.PhysicalAddressStreetLine2;
          this.dataModel.MailSuburb = data.PhysicalAddressSuburb;
          this.dataModel.MailCountry = data.PhysicalAddressCountry;
          this.dataModel.ContactPhoneNo = data.Phone;
          this.dataModel.Email = data.Email;
          this.dataModel.ContactMobileNo = data.Mobile;
        }
      }
    },

    getLineStatusItems(data) {
      const lineStatus = data.LineStatus;
      let lineStatusItems = this.lineStatusItems;

      if (this.baseView.mode == "create" || data.isNewLine) {
        lineStatusItems.find((item) => item.value === "A").visible = false;
      } else {
        if (lineStatus === "A") {
          lineStatusItems.find((item) => item.value === "P").visible = false;
        } else if (lineStatus === "P") {
          lineStatusItems.find((item) => item.value === "A").visible = false;
        } else if (lineStatus === "R" || lineStatus === "S") {
          lineStatusItems.find((item) => item.value === "A").visible = false;
          lineStatusItems.find((item) => item.value === "P").visible = false;
        }
      }

      return lineStatusItems;
    },
    onConsignmentNoteChanged() {
      this.dataModel.Status = "A";
      if (this.headerToolBarForm) {
        let requestStatus = this.headerToolBarForm.getEditor("RequestStatus");
        if (requestStatus) requestStatus.option("value", "A");
      }
    },
    async cancelSampleRequest() {
      let confirmCancel = await this.$confirm(
        "Are you sure you want to Cancel ?",
        "Cancel Sample Request"
      );
      if (confirmCancel) {
        this.checkHeaderFormValidation("Cancelled");
      }
    },
    onPreparedBySelected() {
      if (new Date(this.dataModel.RequestedBy) > new Date())
        this.dataModel.PreparedDate = new Date(this.dataModel.RequestedBy);
      else this.dataModel.PreparedDate = new Date();
      setTimeout(() => {
        this.toNextField("PreparedDate");
      }, 50);
    },
    onSampleSentBySelected() {
      if (new Date(this.dataModel.PreparedDate) > new Date())
        this.dataModel.SampleSentDate = new Date(this.dataModel.PreparedDate);
      else this.dataModel.SampleSentDate = new Date();
      setTimeout(() => {
        this.toNextField("SampleSentDate");
      }, 50);
    },
    onNotifiedBySelected() {
      if (new Date(this.dataModel.SampleSentDate) > new Date())
        this.dataModel.CustomerNotifiedDate = new Date(
          this.dataModel.SampleSentDate
        );
      else this.dataModel.CustomerNotifiedDate = new Date();
      setTimeout(() => {
        this.toNextField("CustomerNotifiedDate");
      }, 50);
    },
    datesFormFields(dataField, disabled) {
      let formInstance =
        this.$refs["gc-header-form-right"].$refs["gc-form-comp"].instance;
      if (formInstance) {
        let field = formInstance.getEditor(dataField).instance();
        if (field) field.option("disabeld", disabled);
      }
    },
    toNextField(dataField) {
      let formInstance =
        this.$refs["gc-header-form-right"].$refs["gc-form-comp"].instance;
      if (formInstance) {
        let field = formInstance.getEditor(dataField).instance();
        if (field) field.focus();
      }
    },
    setSelectedCustomerData(e) {
      if (e.selectedItem) {
        this.selectedCustomerData = e.selectedItem;
      } else {
        this.selectedCustomerData = undefined;
      }
    },
    setSelectedCustomerChanged(e) {
      // in review mode do not do anything

      if (e.component.getDataSource()) {
        var customer = e.component
          .getDataSource()
          ._items.find((x) => x.Code == e.value);

        this.selectedCustomerData = customer;
      }

      if (!e.value || e.value !== e.previousValue) {
        this.dataModel.CustomerContactCode = undefined;
        this.dataModel.MailCountry = undefined;
        this.dataModel.MailPostCode = undefined;
        this.dataModel.MailState = undefined;
        this.dataModel.MailStreet1 = undefined;
        this.dataModel.MailStreet2 = undefined;
        this.dataModel.MailSuburb = undefined;
        this.dataModel.ContactPhoneNo = undefined;
        this.dataModel.ContactMobileNo = undefined;
        this.dataModel.Email = undefined;
      }
    },
    displayDatesWarning(dataField, date) {
      this.$alert(
        `${dataField} cannot be later than the downstream workflow dates assigned. The downstream dates will be automatically updated to ${new Date(
          date
        ).toShortDateString()}`,
        "Warning"
      );
    },
    onRequestedDateValueChanged(e) {
      if (
        this.dataModel.PreparedDate &&
        new Date(e.value) > new Date(this.dataModel.PreparedDate)
      ) {
        this.displayDatesWarning("Requested Date", e.value);
        this.dataModel.PreparedDate = e.value;
        if (
          this.dataModel.SampleSentDate &&
          new Date(e.value) > new Date(this.dataModel.SampleSentDate)
        )
          this.dataModel.SampleSentDate = e.value;

        if (
          this.dataModel.CustomerNotifiedDate &&
          new Date(e.value) > new Date(this.dataModel.CustomerNotifiedDate)
        )
          this.dataModel.CustomerNotifiedDate = e.value;
      }
    },
    onPreparedDateValueChanged(e) {
      if (
        this.dataModel.SampleSentDate &&
        new Date(e.value) > new Date(this.dataModel.SampleSentDate)
      ) {
        this.displayDatesWarning("Prepared Date", e.value);
        this.dataModel.SampleSentDate = e.value;

        if (
          this.dataModel.CustomerNotifiedDate &&
          new Date(e.value) > new Date(this.dataModel.CustomerNotifiedDate)
        )
          this.dataModel.CustomerNotifiedDate = e.value;
      }
    },
    onSampleSentDateValueChanged(e) {
      if (
        this.dataModel.CustomerNotifiedDate &&
        new Date(e.value) > new Date(this.dataModel.CustomerNotifiedDate)
      ) {
        this.displayDatesWarning("Sent Date", e.value);
        this.dataModel.CustomerNotifiedDate = e.value;
      }
    },
  },
  computed: {
    isGridCellEditable() {
      if (this.baseView.mode != "review" && this.dataModel.Status == "Pending")
        return true;
      else return false;
    },
    getCustomButtons() {
      if (this.baseView.mode != "review") {
        let saveOptions = [
          {
            text: "Save",
            onClick: () => {
              this.checkHeaderFormValidation();
            },
          },
        ];
        if (this.baseView.mode == "edit")
          saveOptions.unshift(
            {
              text: "Cancel",
              onClick: () => {
                this.cancelSampleRequest();
              },
              disabled: this.dataModel.Status == "Complete",
            },
            {
              text: "Complete",
              onClick: () => {
                this.checkHeaderFormValidation("Complete");
              },
              disabled:
                this.dataModel.Status !== "Sent" &&
                this.dataModel.Status !== "Notified",
            }
          );
        return saveOptions;
      } else return [];
    },
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    getProductEditor() {
      return [
        {
          dataSourceConfig: {
            endpoint: "api/Product",
            select: [
              "Code",
              "Description1",
              "Inactive",
              "StockItem",
              "PackSize",
            ],
            filter: ["Inactive", "=", "N"],
          },
          editorTemplate: {
            primary: [
              {
                dataField: "Description1",
              },
            ],
            secondary: [
              {
                dataField: "Code",
              },
            ],
          },
          valueExpr: "Code",
          displayExpr: "Code",
        },
      ];
    },
    getGridHeight() {
      return this.gridHeight - 20 - 40 - 55 - this.headerFormHeight;
      // 20 => Top & Bottom Padding
      // 40 => Footer Height
      // 55 => Toolbar Height + Toolbar bottom padding
    },
    leftFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  itemType: "group",
                  caption: "",
                  cssClass: "header-form-items",
                  colCount: 6,
                  items: [
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 1,
                      colSpan: 5,
                      cssClass: "users-column",
                      items: [
                        {
                          label: {
                            text: "Contact",
                          },
                          screenField: "CustomerContactAddress",
                          filter: [
                            ["CustomerCode", "=", this.dataModel.CustomerCode],
                          ],
                          displayExpr: (data) => {
                            if (data)
                              return data.FirstName + " " + data.Surname;
                            else return undefined;
                          },
                          valueExpr: "LineNo",
                          required: true,
                          editorOptions: {
                            tabIndex: 4,
                            onValueChanged: (e) => {
                              this.onCustomerContactChanged(e);
                            },

                            itemTemplate: "Record",
                            allowUpdate: this.isHeaderEditable,
                            onKeyDown: (e) => {
                              if (e.event.keyCode == 9 && e.event.shiftKey) {
                                e.event.preventDefault();
                                this.focusToolbarFormElement("CustomerCode");
                              }
                            },
                          },
                          dataField: "CustomerContactCode",
                        },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 1,
                      cssClass: "date-column",
                      items: [
                        {
                          dataField: "GenerateContact",
                          label: {
                            text: " ",
                            visible: false,
                          },
                          // visible: this.baseView.mode != "review",
                          editorType: "dxButton",
                          cssClass: "btn-add-contact",
                          editorOptions: {
                            tabIndex: 2,
                            onClick: async () => {
                              this.onVisibleAddNewCustomer();
                            },
                            text: "",
                            icon: "plus",
                            type: "default",
                            rtlEnabled: false,
                            allowUpdate:
                              this.dataModel.CustomerCode &&
                              this.isHeaderEditable
                                ? true
                                : false,
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  label: {
                    text: "Email",
                  },
                  dataField: "Email",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  label: {
                    text: "Phone",
                  },
                  dataField: "ContactPhoneNo",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  label: {
                    text: "Mobile",
                  },
                  dataField: "ContactMobileNo",
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "MailStreet1",
                  required: true,
                  editorOptions: {
                    tabIndex: 5,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "MailStreet2",
                  // required: true,
                  editorOptions: {
                    tabIndex: 6,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
                {
                  screenField: "Suburb",
                  dataField: "MailSuburb",
                  required: true,
                  editorOptions: {
                    tabIndex: 7,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
                {
                  screenField: "MailAddressState",
                  dataField: "MailState",
                  required: true,
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                    tabIndex: 8,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
                {
                  screenField: "PostCode",
                  dataField: "MailPostCode",
                  required: true,
                  editorOptions: {
                    tabIndex: 9,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
                {
                  screenField: "MailAddressCountry",
                  dataField: "MailCountry",
                  required: true,
                  editorOptions: {
                    tabIndex: 10,
                    allowUpdate: this.isHeaderEditable,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    rightFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  colSpan: 2,
                  cssClass: "users-column",
                  items: [
                    {
                      screenField: "SalesRepresentative",
                      label: {
                        text: "Requested",
                      },
                      dataField: "RequestedBy",
                      editorOptions: {
                        tabIndex: 11,
                        allowUpdate:
                          this.baseView.mode != "review" &&
                          this.dataModel.Status == "Pending",
                        onValueChanged: (e) => {
                          if (e.event)
                            this.focusRightFormElement("RequestedDate", true);
                        },
                      },
                      required: true,
                      validationRules: [
                        {
                          type: "required",
                          message:
                            "The Requested field is required. Please specify the person that has requested this sample prior to saving",
                        },
                      ],
                    },
                    {
                      screenField: "SalesRepresentative",
                      label: {
                        text: "Prepared",
                      },
                      dataField: "PreparedBy",
                      editorOptions: {
                        tabIndex: 13,
                        allowUpdate:
                          this.dataModel.RequestedBy &&
                          this.baseView.mode != "review" &&
                          this.dataModel.Status != "Sent" &&
                          this.dataModel.Status != "Notified"
                            ? true
                            : false,
                        onValueChanged: (e) => {
                          if (e.event) this.onPreparedBySelected();
                        },
                      },
                      required: this.dataModel.Status == "Prepared",
                    },
                    {
                      screenField: "SalesRepresentative",
                      label: {
                        text: "Sent",
                      },
                      dataField: "SampleSentBy",
                      editorOptions: {
                        tabIndex: 15,
                        allowUpdate:
                          this.dataModel.PreparedBy &&
                          this.baseView.mode != "review" &&
                          this.dataModel.Status != "Notified"
                            ? true
                            : false,
                        onValueChanged: (e) => {
                          if (e.event) this.onSampleSentBySelected();
                        },
                      },
                      required: this.dataModel.Status == "Sent",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  cssClass: "date-column",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "RequestedDate",
                      label: {
                        visible: false,
                        text: "Requested Date",
                      },
                      editorOptions: {
                        tabIndex: 12,
                        allowUpdate:
                          this.baseView.mode != "review" &&
                          this.dataModel.Status == "Pending",
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onRequestedDateValueChanged(e);
                          }
                        },
                        onKeyDown: (e) => {
                          if (e.event.keyCode == 9 && !e.event.shiftKey) {
                            e.event.preventDefault();
                            this.focusRightFormElement("PreparedBy", true);
                          }
                        },
                      },
                      required: true,
                      // Requested date must not be later than other dates
                      //
                    },
                    {
                      screenField: "DateIn",
                      dataField: "PreparedDate",
                      label: {
                        visible: false,
                        text: "Prepared Date",
                      },
                      editorOptions: {
                        min: this.dataModel.RequestedDate,
                        tabIndex: 14,
                        allowUpdate:
                          this.dataModel.RequestedBy &&
                          this.dataModel.RequestedDate &&
                          this.baseView.mode != "review" &&
                          this.dataModel.Status != "Sent" &&
                          this.dataModel.Status != "Notified"
                            ? true
                            : false,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onPreparedDateValueChanged(e);
                          }
                        },
                        onKeyDown: (e) => {
                          if (e.event.keyCode == 9 && !e.event.shiftKey) {
                            e.event.preventDefault();
                            this.focusRightFormElement("SampleSentBy", true);
                          }
                        },
                      },
                      required: this.dataModel.Status == "Prepared",
                    },
                    {
                      screenField: "DateIn",
                      dataField: "SampleSentDate",
                      label: {
                        visible: false,
                        text: "Sent Date",
                      },
                      editorOptions: {
                        min: this.dataModel.PreparedDate,
                        tabIndex: 16,
                        allowUpdate:
                          this.dataModel.PreparedBy &&
                          this.dataModel.PreparedDate &&
                          this.baseView.mode != "review" &&
                          this.dataModel.Status != "Notified"
                            ? true
                            : false,
                        onValueChanged: (e) => {
                          if (e.event) {
                            this.onSampleSentDateValueChanged(e);
                          }
                        },
                        onKeyDown: (e) => {
                          if (e.event.keyCode == 9 && !e.event.shiftKey) {
                            e.event.preventDefault();
                            this.focusRightFormElement(
                              "FreightCarrierCode",
                              true
                            );
                          }
                        },
                      },
                      required: this.dataModel.Status == "Sent",
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 1,
              items: [
                {
                  screenField: "FreightCarrier",
                  label: {
                    text: "Carrier",
                  },
                  // displayExpr: "Code",
                  editorOptions: {
                    tabIndex: 17,
                    onSelectionChanged: (e) => {
                      if (e) {
                        this.onFreightCarrierChanged(e);
                      }
                    },
                    allowUpdate:
                      this.dataModel.SampleSentBy &&
                      this.baseView.mode != "review" &&
                      this.dataModel.Status != "Notified"
                        ? true
                        : false,
                  },
                  required:
                    this.dataModel.SampleSentBy ||
                    this.dataModel.Status == "Sent"
                      ? true
                      : false,
                },
                {
                  label: {
                    text: "Tracking ID",
                  },
                  dataField: "ConsignmentNote",
                  editorType: "dxTextBox",
                  editorOptions: {
                    tabIndex: 18,
                    placeholder: "Tracking ID",

                    // onValueChanged: (e) => {
                    //   if (e.event) {
                    //     this.onConsignmentNoteChanged();
                    //   }
                    // },
                    allowUpdate:
                      this.dataModel.SampleSentBy &&
                      this.baseView.mode != "review" &&
                      this.dataModel.Status != "Notified"
                        ? true
                        : false,
                  },
                  required:
                    this.dataModel.SampleSentBy ||
                    this.dataModel.Status == "Sent"
                      ? true
                      : false,
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              cssClass: "header-form-items",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  colSpan: 2,
                  cssClass: "users-column",
                  items: [
                    {
                      screenField: "SalesRepresentative",
                      dataField: "CustomerNotifiedBy",
                      label: {
                        text: "Notified",
                      },
                      editorOptions: {
                        tabIndex: 19,
                        allowUpdate:
                          this.dataModel.SampleSentBy &&
                          this.baseView.mode != "review"
                            ? true
                            : false,
                        // allowUpdate: true,
                        onValueChanged: (e) => {
                          if (e.event) this.onNotifiedBySelected();
                        },
                      },
                      // required: this.dataModel.Status == "Sent",
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 1,
                  cssClass: "date-column",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "CustomerNotifiedDate",
                      label: {
                        visible: false,
                        text: "Notified Date",
                      },
                      editorOptions: {
                        min: this.dataModel.SampleSentDate,
                        tabIndex: 20,
                        allowUpdate:
                          this.dataModel.SampleSentBy &&
                          this.dataModel.SampleSentDate &&
                          this.baseView.mode != "review"
                            ? true
                            : false,
                        onKeyDown: (e) => {
                          if (e.event.keyCode == 9 && !e.event.shiftKey) {
                            e.event.preventDefault();
                            this.moveCellFoucs({ rowIndex: 0 }, "ProductCode");
                          }
                        },
                      },
                      // required: this.dataModel.Status == "Sent",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        screenName: "Sample Request",
        pdf: false,
        audit: this.baseView.mode == "review",
        status: true,
        notes: false,
        edit: false,
        save:
          this.baseView.mode == "review" &&
          (this.dataModel.Status == "Complete" ||
            this.dataModel.Status == "Cancelled")
            ? false
            : this.baseView.mode == "create" || this.baseView.mode == "edit"
            ? false
            : true,
        editURL: "/sample-request",
        headerFormVisible: true,
        toolbarFormItems: [
          {
            itemType: "group",
            caption: "",
            cssClass: "header-form-items",
            colCount: 3,
            items: [
              {
                screenField: "Customer",
                dataField: "CustomerCode",
                cssClass: "toolbar-customer-label",
                // visible: this.baseView.mode != "review",
                editorOptions: {
                  tabIndex: 1,
                  dropDownOptions: {
                    minWidth: 300,
                  },
                  width: 300,
                  placeholder: "Customer Name",
                  showClearButton: true,
                  onFocusIn: (e) => {
                    e.event.target.select();
                  },
                  allowUpdate: this.isHeaderEditable,
                  onValueChanged: (e) => {
                    this.setSelectedCustomerChanged(e);
                  },
                  onKeyDown: (e) => {
                    if (e.event.keyCode == 9 && !e.event.shiftKey) {
                      e.event.preventDefault();
                      this.focusLeftFormElement("CustomerContactCode");
                    }
                  },
                },
                label: {
                  text: "Customer",
                  visible: false,
                },
                required: true,
              },
              {
                dataField: "Generate",
                label: {
                  text: " ",
                  visible: false,
                },
                visible: this.baseView.mode != "review",
                editorType: "dxButton",
                cssClass: "btn-add-customer",
                editorOptions: {
                  tabIndex: 2,
                  validationGroup: "gc-header-form",
                  onClick: async () => {
                    this.onVisibleAddNewCustomer();
                  },
                  text: "",
                  icon: "plus",
                  type: "default",
                  rtlEnabled: false,
                  allowUpdate:
                    !this.dataModel.CustomerCode && this.isHeaderEditable,
                },
              },
            ],
          },
        ],
        // saveCallback: this.saveBankReconciliation,
        formContentReady: this.toolBarFormContentReady,
      };
    },

    backButtonRoute() {
      if (this.baseView && this.baseView.query && this.baseView.query.from)
        return this.baseView.query.from;
      else return "/sample-request";
    },

    getDataSource() {
      return new DataSource({
        store: this.localDataSourceItems._array,
        reshapeOnPush: true,
      });
    },

    getProductDataSource() {
      return ProductService.dataSourceConfig("api/Product", {
        select: ["Code", "Description1", "Inactive", "StockItem", "PackSize"],
        filter: ["Inactive", "=", "N"],
      });
    },
    isHeaderEditable() {
      if (
        this.baseView.mode != "review" &&
        (this.dataModel.Status == "Pending" ||
          this.dataModel.Status == "Prepared")
      )
        return true;
      else return false;
    },
  },
};
</script>

<style lang="scss">
.sample-request {
  .view-toolbar .dx-form .dx-item-content .dx-item.dx-box-item {
    width: 500px !important;
  }
  .gc-header-toolbar {
    // padding: unset !important;
    .btn-add-customer {
      text-align: end;
      margin-left: 125px;
      .dx-widget.dx-button {
        background-color: white !important;
        .dx-icon.dx-icon-plus::before {
          color: #03a9f4 !important;
        }
      }

      .dx-widget.dx-button.dx-state-hover {
        background-color: #03a9f4 !important;
        .dx-icon.dx-icon-plus::before {
          color: white !important;
        }
      }
    }

    .dx-button[aria-label="Save"] {
      background-color: #03a9f4;
      color: #fff !important;
      .dx-button-content .dx-icon::before {
        color: #fff !important;
      }
    }

    .dx-button[aria-label="Save"].dx-state-hover {
      background-color: #028bc9;
    }

    .dx-button[aria-label="Cancel"] {
      border: 1px solid #ff0000;
      color: red;
      .dx-button-content .dx-icon::before {
        color: #ff0000 !important;
      }
    }

    .dx-button[aria-label="Cancel"].dx-state-hover {
      background-color: #ff000036;
      color: red;
    }

    .dx-button[aria-label="Complete"] {
      border: 1px solid #a2a2a2;
      .dx-button-content .dx-icon::before {
        color: #000000 !important;
      }
    }
  }
  .gc-header-form {
    .btn-add-contact {
      .dx-widget.dx-button {
        background-color: white !important;
        .dx-icon.dx-icon-plus::before {
          color: #03a9f4 !important;
        }
      }

      .dx-widget.dx-button.dx-state-hover {
        background-color: #03a9f4 !important;
        .dx-icon.dx-icon-plus::before {
          color: white !important;
        }
      }
    }
    .header-form-container {
      display: inline-flex;
      width: 100%;
      // padding: 0px 12px;
      .header-form {
        width: calc(100% / 5 * 3);
        margin-bottom: 0px !important;
      }

      .header-comments {
        margin-left: 12px;
        width: calc(100% / 5 * 2);
      }
    }

    .header-form-items
      .dx-form-group
      .dx-item
      > .dx-item-content
      > .dx-last-col {
      padding-bottom: unset !important;
    }

    .users-column {
      padding-right: unset;
    }
  }

  .gc-details-grid {
    // padding: 0px 12px;
    .gc-editable-field:not([role="columnheader"]) {
      .dx-texteditor.dx-editor-underlined:not(.dx-state-disabled):after {
        content: "";
        display: block;
        border-bottom: 1px solid #949494;
        margin-top: -1px; /* Adjust this value to position the underline properly */
      }

      .dx-texteditor.dx-editor-underlined.dx-state-disabled:not(
          .parent-cell-element
        ):after {
        content: "";
        display: block;
        border-bottom: 1px dotted #949494;
        margin-top: -1px; /* Adjust this value to position the underline properly */
      }

      .dx-texteditor.dx-editor-underlined.dx-state-disabled:not(
          .parent-cell-element
        ) {
        opacity: 1 !important;
      }

      //   .dx-texteditor.dx-editor-underlined .dx-texteditor-input-container {
      //     input {
      //       height: 20px;
      //     }
      //   }

      .dx-texteditor .dx-placeholder::before {
        padding: unset !important;
      }
    }

    .dx-row.dx-data-row {
      td.gc-editable-field:not(:first-child) {
        padding-left: 5px !important;
        padding-right: 5px !important;
      }
    }
    .dx-link {
      color: #03a9f4 !important;
    }

    .instructions-text .instructions-text-area:not(.review-mode) {
      textarea {
        height: 45px !important;
        line-height: 16px !important;
      }
    }

    .instructions-text .instructions-text-area.review-mode::after {
      content: unset !important;
    }

    .dx-row.dx-data-row.dx-row-lines {
      td {
        align-content: flex-end;
      }
    }

    // gc-editable-field gc-editor-product-cell dx-datagrid-validator dx-validator dx-visibility-change-handler
    // gc-editable-field gc-editor-product-cell dx-editor-cell dx-datagrid-validator dx-validator dx-visibility-change-handler dx-datagrid-invalid dx-focused

    .gc-editable-field.gc-editor-product-cell:not(
        .dx-editor-cell
      )[role="gridcell"]::after {
      content: "";
      display: block;
      border-bottom: 1px solid #949494;
      margin-top: -1px;
    }
  }

  .gc-grid-footer-css-v2 {
    .gc-grid-footer {
      height: 40px;
    }
  }

  .gc-details-grid.gc-details-grid-review-mode {
    .dx-row.dx-data-row.dx-row-lines {
      td {
        align-content: flex-start !important;
      }
    }
  }
}
</style>
